/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Language_FrenchInputs */

const fr_language_french = /** @type {(inputs: Language_FrenchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const en_language_french = /** @type {(inputs: Language_FrenchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`French`)
};

/**
* | output |
* | --- |
* | "French" |
*
* @param {Language_FrenchInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const language_french = /** @type {((inputs?: Language_FrenchInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Language_FrenchInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_language_french(inputs)
	return en_language_french(inputs)
});